<template>
  <v-form ref="formulario">
    <v-card flat class="fill-height">
      <v-card-text>
        <v-layout wrap>

          <v-flex xs12>
            <provider-title title="Herramientas" />
          </v-flex>

          <v-flex xs12>
            <v-divider class="my-3"></v-divider>
            <provider-sub-title text="Cobrar"/>
          </v-flex>

          <v-flex xs12>

            <div class="my-4" v-if="!allowOnlinePayments">
              <div class="body-2"> Tu plan actual no incluye cobros en línea.</div>
              <div class="mt-2" v-if="allowVC">
                ¿Necesitas esta característica?
                <br/>
                <buy-new-plan-btn/>
              </div>
            </div>

            <template v-else>
              <v-switch
                  color="primary"
                  :disabled="!paymentAccountWasSet || !paymentAccountWasVerified"
                  prepend-icon="fa-credit-card"
                  label="Cobrar atención en línea"
                  v-model="request_online_payment"
                  hide-details
              ></v-switch>
              <div class="caption mt-3" v-if="!paymentAccountWasSet">
                <span>Para recibir pagos, el dueño de la cuenta debe configurar primero una <a v-if="isOwner" @click="$emit('click:payment-account')">Cuenta de Cobro</a> <b v-else>Cuenta de Cobro</b>.</span>
              </div>
              <div class="caption mt-3" v-if="paymentAccountWasSet && !paymentAccountWasVerified">
                <span>Tu <b>Cuenta de Cobro</b> aún no ha sido verificada.</span>
                <div>No podrás recibir pagos hasta que esto ocurra.</div>
              </div>
            </template>


            <v-slide-y-transition>

              <div v-show="request_online_payment">
                <v-layout wrap>
                  <v-flex xs12 md4 lg3 mt-3 mb-3>
                    <v-select
                            label="Manejador de cobros"
                            prepend-inner-icon="fa-file-invoice-dollar"
                            :items="handlerOptions"
                            :value="online_payment_handler"
                            v-model="online_payment_handler"
                            :hint="paymentHandlerHint"
                            persistent-hint
                    />
                  </v-flex>
                </v-layout>

                <v-slide-y-transition>

                  <div v-show="online_payment_handler === 'kim'">

                    <v-layout wrap align-center>
                      <v-flex xs12 sm6 md4 lg3 pr-1 mb-2>
                          <v-text-field
                              hide-details
                              label="Valor consulta particular"
                              :value="private_attention_price | number"
                              @input="value => private_attention_price = value"
                              prepend-inner-icon="fa-dollar-sign"
                          />

                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm6 md4 lg3 pr-1 mb-2>
                        <v-text-field
                                hide-details
                                label="Valor consulta Fonasa"
                                :value="fonasa_attention_price | number"
                                @input="value => fonasa_attention_price = value"
                                prepend-inner-icon="fa-dollar-sign"
                        />
                      </v-flex>
                      <v-flex xs12 sm6 md4 lg3 pl-1 pt-2 mb-2 hidden-sm-and-down>

                        <v-btn small @click="setFonasaEqual" :disabled="fonasaEqualToPrivate">
                          copiar particular
                        </v-btn>

                      </v-flex>

                    </v-layout>

                    <v-layout wrap>
                      <v-flex xs12 sm6 md4 lg3 pl-1 mb-2>

                        <v-text-field
                                hide-details
                                label="Valor consulta Isapre"
                                :value="isapre_attention_price | number"
                                @input="value => isapre_attention_price = value"
                                prepend-inner-icon="fa-dollar-sign"
                        />
                      </v-flex>

                      <v-flex xs12 sm6 md4 lg3 pl-1 pt-2 mb-2 hidden-sm-and-down>

                        <v-btn
                                small
                                @click="setIsapreEqual" :disabled="isapreEqualToPrivate"
                        >copiar particular</v-btn>

                      </v-flex>

                    </v-layout>

                  </div>
                </v-slide-y-transition>

              </div>

            </v-slide-y-transition>
          </v-flex>

          <v-flex xs12>
            <v-divider class="my-3"></v-divider>
            <provider-sub-title text="Video Llamada"/>
          </v-flex>

          <v-flex xs12 class="mt-0 pt-0">

            <div class="my-4" v-if="!allowVC">
              <div class="body-2"> Tu plan actual no incluye atención por videollamada.</div>
              <div class="mt-2" v-if="allowOnlinePayments">
                ¿Necesitas esta característica?
                <br/>
                <buy-new-plan-btn/>
              </div>
            </div>

            <v-switch
                v-else
                color="primary"
                prepend-icon="fa-video"
                label="Permitir atención por video"
                v-model="allow_vc"
                hide-details
            ></v-switch>

          </v-flex>

        </v-layout>
      </v-card-text>
      <v-card-actions v-if="allowVC || allowOnlinePayments">
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="primary" @click="submit" :loading="loading">Guardar</v-btn>
      </v-card-actions>
      <template v-else>
        <v-divider></v-divider>
        <div class="text-center mt-4">
          ¿Necesitas alguna de estas características?
          <br/>
          <buy-new-plan-btn/>
        </div>
      </template>

    </v-card>
  </v-form>
</template>

<script>

import {mapState, mapMutations, mapGetters} from 'vuex'
  import {ApiUtils} from '@/utils/ApiUtils'
  import BuyNewPlanBtn from "../../subscription/BuyNewPlanBtn";
import ProviderSubTitle from "@/components/providers/panel/ProviderSubTitle";

export default {
  components: {
    ProviderSubTitle,
    BuyNewPlanBtn,
    ProviderTitle: () => import('@/components/providers/panel/ProviderTitle')
  },
  props: {},
  data() {
    return {

      error: '',

      allow_vc: false,
      request_online_payment: false,
      allow_medical_voucher_attention: false,
      allow_public_schedule_post_message: false,
      online_payment_handler: 'kim',
      private_attention_price: '0',
      fonasa_attention_price: '0',
      isapre_attention_price: '0',

      loading: false,
      emailPersonal: false,
      emailRules: [
        v => {
          if (!this.emailPersonal) {
            return /.+@.+/.test(v) || 'E-mail inválido'
          } else {
            return true
          }
        }
      ]
    }
  },
  watch: {
    noQuotations: function(val) {
      if (val) {
        this.quotation_expiration_days = 0
      }
    },
    emailPersonal: function(val) {
      if (val) {
        this.notification_email = this.currentUser.email
      } else {
        this.notification_email = ''
      }
    }
  },
  mounted() {
    this.loadDefault()
    this.error = ''
  },
  computed: {
    ...mapState(['currentUser', 'currentProvider']),
    ...mapGetters(['allowOnlinePayments', 'allowVC']),
    isOwner(){
      var vm = this
      const isOwner = !!vm.currentProvider && vm.currentProvider.role.is_owner
      return isOwner
    },
    paymentAccountWasSet(){

      var vm = this
      const {settings: {payment_account}} = vm.currentProvider
      return !!payment_account

    },
    paymentAccountWasVerified(){

      var vm = this
      const {settings: {payment_account}} = vm.currentProvider
      return !!payment_account && payment_account.verified

    },
    valid(){
      var vm = this
      if(vm.request_online_payment && (
          Number(vm.private_attention_price) === 0 ||
          Number(vm.fonasa_attention_price) === 0 ||
          Number(vm.isapre_attention_price) === 0
      )) return false

      return true
    },
    fonasaEqualToPrivate(){
        var vm = this
        return vm.fonasa_attention_price === vm.private_attention_price
    },
    isapreEqualToPrivate(){
        var vm = this
        return vm.isapre_attention_price === vm.private_attention_price
    },
    paymentHandlerHint(){
      var vm = this
      return vm.online_payment_handler === 'kim' ?
              'Todas las consultas se cobrarán con transbank.' :
              'Consultas particulares se cobrarán con transbank, en cualquier otro caso se solicitarán datos del bono.'
    },
    handlerOptions(){

        return [
            'kim',
            'i-med'
        ]

    },
    payload(){

      var vm = this
      const payload = {
        allow_vc: vm.allow_vc ? 1 : 0,
        request_online_payment: vm.request_online_payment ? 1 : 0,
      }

      if(payload.request_online_payment){
        return {
          ...payload,
          allow_medical_voucher_attention: vm.allow_medical_voucher_attention ? 1 :0,
          online_payment_handler: vm.online_payment_handler,
          private_attention_price: vm.private_attention_price.replace(/\./g, ''),
          fonasa_attention_price: vm.fonasa_attention_price.replace(/\./g, ''),
          isapre_attention_price: vm.isapre_attention_price.replace(/\./g, ''),
        }
      }

      return payload

    }
  },
  methods: {
    ...mapMutations(['showSnackBar']),
    ...mapGetters(['specialistSettings']),
    loadDefault(){

      var vm = this
      const specialistSetttings = vm.specialistSettings

      vm.allow_vc = !!specialistSetttings && specialistSetttings.allow_vc
      vm.request_online_payment = !vm.paymentAccountWasSet || !vm.paymentAccountWasVerified ? false : !!specialistSetttings && specialistSetttings.request_online_payment || false
      vm.allow_medical_voucher_attention = !!specialistSetttings &&  specialistSetttings.allow_medical_voucher_attention || false
      vm.private_attention_price = !!specialistSetttings &&  String(specialistSetttings.private_attention_price) || '0'
      vm.fonasa_attention_price = !!specialistSetttings &&  String(specialistSetttings.fonasa_attention_price) || '0'
      vm.isapre_attention_price = !!specialistSetttings &&  String(specialistSetttings.isapre_attention_price) || '0'

    },
    setFonasaEqual(){
      var vm = this
      vm.fonasa_attention_price = vm.private_attention_price
    },
    setIsapreEqual(){
      var vm = this
      vm.isapre_attention_price = vm.private_attention_price
    },
    async submit() {

      var vm = this
      vm.error = ''
      if(vm.loading || !vm.currentProvider) return
      const {id} = vm.currentProvider
      this.loading = true
      const response = await ApiUtils.makePatch(`provider/${id}/settings/specialist`, null, vm.payload)
      this.loading = false

      if(!response.ok){
        const json = await response.json()
        vm.error = json.message || 'Ocurrió un error intentando guardar la configuración'
        return
      }

      vm.showSnackBar({
        text: 'Configuración actualizada',
        color: 'success'
      })
      await ApiUtils.fetchMe()

    }
  }
}
</script>
<style scoped>
.ancho {
  max-width: 300px;
}
</style>
